import PropTypes from "prop-types";

const propTypes = {
  typPrace: PropTypes.shape({
    I_TYP_PRACE: PropTypes.number,
    N_TYP_PRACE: PropTypes.string,
  }),
};

export default propTypes;
